import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { trackerActions } from '../slices/tracker/slice';
const useTracker = () => {
  const dispatch = useDispatch();
  const usageTracker = useMemo(() => ({
    trackInteraction: data => {
      dispatch(trackerActions.trackInteraction(data));
    },
    trackPageView: screen => {
      dispatch(trackerActions.trackPageView(screen));
    },
    trackUsage: data => {
      dispatch(trackerActions.trackUsage(data));
    }
  }), [dispatch]);
  return usageTracker;
};
export default useTracker;